
import React from 'react';
import { Table } from 'semantic-ui-react';
import moment from 'moment';

const PaidBills = ({ mappedBills }) => {

    return (
        <>
            <Table unstackable size="large" compact="very" className="w3-small">
                <Table.Header>
                    <Table.Row >
                        <Table.HeaderCell className="labelName p-bold-600">Bill Date</Table.HeaderCell>
                        <Table.HeaderCell className="labelName p-bold-600">Partner Bill No</Table.HeaderCell>
                        <Table.HeaderCell className="labelName p-bold-600">Partner Branch Name</Table.HeaderCell>
                        <Table.HeaderCell className="labelName p-bold-600">Bill Due Date</Table.HeaderCell>
                        <Table.HeaderCell className="labelName p-bold-600">Bill Amount</Table.HeaderCell>
                        <Table.HeaderCell className="labelName p-bold-600">Paid Amount</Table.HeaderCell>
                        {/* <Table.HeaderCell className="labelName p-bold-600">Amount Due</Table.HeaderCell> */}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {mappedBills && mappedBills.map((object, index) => {

                        return (
                            <Table.Row verticalAlign="middle" key={index}>

                                <React.Fragment>
                                    <Table.Cell>
                                        {mappedBills[index].billDate ? moment(mappedBills[index].billDate).format("DD-MM-YYYY") : ""}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {mappedBills[index].vendorBillNo}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {mappedBills[index].branchName}
                                    </Table.Cell>
                                    <Table.Cell >
                                        {mappedBills[index].billDueDate ? moment(mappedBills[index].billDueDate).format("DD-MM-YYYY") : "NA"}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {mappedBills[index].billAmount}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {Number(mappedBills[index].paidAmount).toFixed(2)}
                                    </Table.Cell>
                                    {/* <Table.Cell>
                                        {mappedBills[index].amountDue}
                                    </Table.Cell> */}
                                </React.Fragment>
                            </Table.Row>
                        )
                    }
                    )}
                </Table.Body>
            </Table>
        </>
    )
}

export default PaidBills
